import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=00bad9e6&scoped=true&"
import script from "./volunteer.vue?vue&type=script&lang=ts&"
export * from "./volunteer.vue?vue&type=script&lang=ts&"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=00bad9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bad9e6",
  null
  
)

export default component.exports